const COLORS = {
  PRIMARY: "bg-[#518c7d]",
  TEXT_FORM: "text-[#667085]",
  TEXT_WHITE: "text-white",
  TEXT_PRIMARY: "text-[#518c7d]",
  TEXT_POPUP: "text-[#667085]",
};
const LINES = [
  "#3FD4DF",
  "#518C7D",
  "#0F231E",
  "#0369FF",
  "#3F76C6",
  " #518C7D",
  "#0369FF",
  "#6AA6FF"
];
export { COLORS, LINES };
